import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "w-full p-input-icon-left mb-3"
}

import { onMounted, ref, toRefs } from 'vue';
import { storeToRefs } from 'pinia';
import { useAttendanceStore, useOrganizationStore } from '@/store';
import LowAttendance from './LowAttendance.vue';
import { can } from '@/composables';
import { PERMISSIONS } from '@/enum';
import { useToast } from 'primevue/usetoast';

interface EvaluationPropsInterface {
  organizationsIds?: number[];
}


export default /*@__PURE__*/_defineComponent({
  __name: 'Attendance',
  props: {
    organizationsIds: {}
  },
  setup(__props: any) {

const dates = ref<Date[]>([]);
const attendanceStore = useAttendanceStore();
const organizationStore = useOrganizationStore();
const { start_at, end_at, loading } = storeToRefs(attendanceStore);
const { organizationsIdsSelected } = storeToRefs(organizationStore);
const toast = useToast();

const props = __props;
const { organizationsIds } = toRefs(props);

onMounted(() => init());

const init = async () => {
  attendanceStore.filteredStudent = null;
  setDefaultDates();

  const organizationIdToSee = !can([PERMISSIONS.WIDGET_EVALUATION_ALL_BY_ORGANIZATIONS]) ? organizationsIds?.value : [];
  const organizationsIdToEvaluate: number[] | undefined =
    organizationsIdsSelected.value.length == 0 ? organizationIdToSee : organizationsIdsSelected.value;

  await attendanceStore.getAllAttendance(organizationsIdToEvaluate || []);
};

const setDefaultDates = () => {
  if (!can([PERMISSIONS.WIDGET_ATTENDANCE_LOW_ATTENDANCE, PERMISSIONS.WIDGET_ATTENDANCE_ALL])) {
    doToast(true, 'Insufficient permissions to view low attendance data.');
    return;
  }

  const userDateInterval = [-28, 0];
  const start = new Date();
  const end = new Date();
  end.setDate(end.getDate() + userDateInterval[1]);
  start.setDate(start.getDate() + userDateInterval[0]);
  dates.value = [start, end];
  attendanceStore.setDates(start.toJSON().split('T')[0], end.toJSON().split('T')[0]);
};

const doToast = (error = false, msg: string) => {
  toast.add({
    severity: error ? 'error' : 'success',
    summary: error ? 'Error' : 'Saved',
    detail: msg,
    life: 5000,
  });
};

const onDateRangeChange = async (dateArray: Date[]) => {
  const start_date = dateArray[0]?.toJSON()?.split('T')[0];
  const end_date = dateArray[1]?.toJSON()?.split('T')[0];

  if (start_date && end_date) {
    attendanceStore.setDates(start_date, end_date);
    await attendanceStore.onDateRangeChange(organizationsIdsSelected.value);
  }
};

return (_ctx: any,_cache: any) => {
  const _component_AppDateRangePicker = _resolveComponent("AppDateRangePicker")!
  const _component_Skeleton = _resolveComponent("Skeleton")!
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createBlock(_component_Card, { class: "page-content-half flex flex-column" }, {
    header: _withCtx(() => [...(_cache[1] || (_cache[1] = [
      _createElementVNode("span", { class: "material-icons text-color-blue mr-2" }, "event", -1),
      _createElementVNode("h2", null, "Attendance", -1)
    ]))]),
    content: _withCtx(() => [
      ((_unref(start_at) || !_unref(loading)) && _unref(can)([_unref(PERMISSIONS).DASHBOARD_OVERVIEW_ATTENDACE_WIDGET_DATE_VIEW]))
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_AppDateRangePicker, {
              modelValue: dates.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((dates).value = $event)),
              class: "w-full",
              value: dates.value,
              onChange: onDateRangeChange
            }, null, 8, ["modelValue", "value"])
          ]))
        : (_openBlock(), _createBlock(_component_Skeleton, {
            key: 1,
            shape: "rectangle",
            class: "mb-3",
            style: {"min-height":"36px"}
          })),
      (_unref(can)([_unref(PERMISSIONS).WIDGET_ATTENDANCE_LOW_ATTENDANCE]) && _unref(start_at) && _unref(end_at))
        ? (_openBlock(), _createBlock(LowAttendance, { key: 2 }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})